/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getDocumentNumber = /* GraphQL */ `query GetDocumentNumber($id: ID!) {
  getDocumentNumber(id: $id) {
    id
    format
    lastUpdate
    incrementNumber
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDocumentNumberQueryVariables,
  APITypes.GetDocumentNumberQuery
>;
export const listDocumentNumbers = /* GraphQL */ `query ListDocumentNumbers(
  $filter: ModelDocumentNumberFilterInput
  $limit: Int
  $nextToken: String
) {
  listDocumentNumbers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      format
      lastUpdate
      incrementNumber
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDocumentNumbersQueryVariables,
  APITypes.ListDocumentNumbersQuery
>;
export const syncDocumentNumbers = /* GraphQL */ `query SyncDocumentNumbers(
  $filter: ModelDocumentNumberFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncDocumentNumbers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      format
      lastUpdate
      incrementNumber
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncDocumentNumbersQueryVariables,
  APITypes.SyncDocumentNumbersQuery
>;
export const getAdminCommunication = /* GraphQL */ `query GetAdminCommunication($id: ID!) {
  getAdminCommunication(id: $id) {
    id
    body
    clientId
    createdAt
    externalId
    applicationInvoice {
      id
      amount
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMethodId
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      createdAt
      dueDate
      invoiceDate
      invoiceLines {
        nextToken
        startedAt
        __typename
      }
      invoiceNumber
      periodFrom
      periodTo
      clientSnapshot {
        name
        vat
        businessNumber
        email
        __typename
      }
      peppolProperties {
        peppolStatus
        peppolId
        peppolErrorType
        peppolErrorMessage
        __typename
      }
      status
      type
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    applicationInvoiceId
    recipient
    sentAt
    status
    subject
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAdminCommunicationQueryVariables,
  APITypes.GetAdminCommunicationQuery
>;
export const listAdminCommunications = /* GraphQL */ `query ListAdminCommunications(
  $filter: ModelAdminCommunicationFilterInput
  $limit: Int
  $nextToken: String
) {
  listAdminCommunications(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      body
      clientId
      createdAt
      externalId
      applicationInvoice {
        id
        amount
        applicationSubscriptionId
        clientId
        createdAt
        dueDate
        invoiceDate
        invoiceNumber
        periodFrom
        periodTo
        status
        type
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      applicationInvoiceId
      recipient
      sentAt
      status
      subject
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAdminCommunicationsQueryVariables,
  APITypes.ListAdminCommunicationsQuery
>;
export const syncAdminCommunications = /* GraphQL */ `query SyncAdminCommunications(
  $filter: ModelAdminCommunicationFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncAdminCommunications(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      body
      clientId
      createdAt
      externalId
      applicationInvoice {
        id
        amount
        applicationSubscriptionId
        clientId
        createdAt
        dueDate
        invoiceDate
        invoiceNumber
        periodFrom
        periodTo
        status
        type
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      applicationInvoiceId
      recipient
      sentAt
      status
      subject
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncAdminCommunicationsQueryVariables,
  APITypes.SyncAdminCommunicationsQuery
>;
export const adminCommunicationsByClientIdAndCreatedAt = /* GraphQL */ `query AdminCommunicationsByClientIdAndCreatedAt(
  $clientId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAdminCommunicationFilterInput
  $limit: Int
  $nextToken: String
) {
  adminCommunicationsByClientIdAndCreatedAt(
    clientId: $clientId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      body
      clientId
      createdAt
      externalId
      applicationInvoice {
        id
        amount
        applicationSubscriptionId
        clientId
        createdAt
        dueDate
        invoiceDate
        invoiceNumber
        periodFrom
        periodTo
        status
        type
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      applicationInvoiceId
      recipient
      sentAt
      status
      subject
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AdminCommunicationsByClientIdAndCreatedAtQueryVariables,
  APITypes.AdminCommunicationsByClientIdAndCreatedAtQuery
>;
export const adminCommunicationsByExternalId = /* GraphQL */ `query AdminCommunicationsByExternalId(
  $externalId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAdminCommunicationFilterInput
  $limit: Int
  $nextToken: String
) {
  adminCommunicationsByExternalId(
    externalId: $externalId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      body
      clientId
      createdAt
      externalId
      applicationInvoice {
        id
        amount
        applicationSubscriptionId
        clientId
        createdAt
        dueDate
        invoiceDate
        invoiceNumber
        periodFrom
        periodTo
        status
        type
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      applicationInvoiceId
      recipient
      sentAt
      status
      subject
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AdminCommunicationsByExternalIdQueryVariables,
  APITypes.AdminCommunicationsByExternalIdQuery
>;
export const adminCommunicationsByApplicationInvoiceId = /* GraphQL */ `query AdminCommunicationsByApplicationInvoiceId(
  $applicationInvoiceId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAdminCommunicationFilterInput
  $limit: Int
  $nextToken: String
) {
  adminCommunicationsByApplicationInvoiceId(
    applicationInvoiceId: $applicationInvoiceId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      body
      clientId
      createdAt
      externalId
      applicationInvoice {
        id
        amount
        applicationSubscriptionId
        clientId
        createdAt
        dueDate
        invoiceDate
        invoiceNumber
        periodFrom
        periodTo
        status
        type
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      applicationInvoiceId
      recipient
      sentAt
      status
      subject
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AdminCommunicationsByApplicationInvoiceIdQueryVariables,
  APITypes.AdminCommunicationsByApplicationInvoiceIdQuery
>;
export const getAdminFile = /* GraphQL */ `query GetAdminFile($id: ID!) {
  getAdminFile(id: $id) {
    id
    bucket
    createdAt
    foreignKey
    foreignTableName
    key
    mimeType
    region
    size
    clientId
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAdminFileQueryVariables,
  APITypes.GetAdminFileQuery
>;
export const listAdminFiles = /* GraphQL */ `query ListAdminFiles(
  $filter: ModelAdminFileFilterInput
  $limit: Int
  $nextToken: String
) {
  listAdminFiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      bucket
      createdAt
      foreignKey
      foreignTableName
      key
      mimeType
      region
      size
      clientId
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAdminFilesQueryVariables,
  APITypes.ListAdminFilesQuery
>;
export const syncAdminFiles = /* GraphQL */ `query SyncAdminFiles(
  $filter: ModelAdminFileFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncAdminFiles(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      bucket
      createdAt
      foreignKey
      foreignTableName
      key
      mimeType
      region
      size
      clientId
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncAdminFilesQueryVariables,
  APITypes.SyncAdminFilesQuery
>;
export const adminFilesByForeignKeyAndForeignTableName = /* GraphQL */ `query AdminFilesByForeignKeyAndForeignTableName(
  $foreignKey: ID!
  $foreignTableName: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAdminFileFilterInput
  $limit: Int
  $nextToken: String
) {
  adminFilesByForeignKeyAndForeignTableName(
    foreignKey: $foreignKey
    foreignTableName: $foreignTableName
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      bucket
      createdAt
      foreignKey
      foreignTableName
      key
      mimeType
      region
      size
      clientId
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AdminFilesByForeignKeyAndForeignTableNameQueryVariables,
  APITypes.AdminFilesByForeignKeyAndForeignTableNameQuery
>;
export const adminFilesByClientIdAndForeignTableName = /* GraphQL */ `query AdminFilesByClientIdAndForeignTableName(
  $clientId: ID!
  $foreignTableName: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAdminFileFilterInput
  $limit: Int
  $nextToken: String
) {
  adminFilesByClientIdAndForeignTableName(
    clientId: $clientId
    foreignTableName: $foreignTableName
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      bucket
      createdAt
      foreignKey
      foreignTableName
      key
      mimeType
      region
      size
      clientId
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AdminFilesByClientIdAndForeignTableNameQueryVariables,
  APITypes.AdminFilesByClientIdAndForeignTableNameQuery
>;
export const getApplicationInvoice = /* GraphQL */ `query GetApplicationInvoice($id: ID!) {
  getApplicationInvoice(id: $id) {
    id
    amount
    applicationSubscriptionId
    applicationSubscription {
      id
      clientId
      creditsBalancePaid
      creditsBalanceIncluded
      creditsConfiguration {
        allowPostPaid
        creditsNotification
        postPaidThreshold
        __typename
      }
      endDate
      language
      lastInvoiceDate
      paymentCustomerId
      paymentLastExecution
      paymentLastStatus
      paymentLastError
      paymentMethodId
      paymentMode
      paymentTerms
      invoicesProperties {
        hideQuantities
        __typename
      }
      plan {
        id
        calculationMethod
        isBillable
        isDefaultPlan
        numberOfTrialMonths
        setupFees
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      planId
      referenceNumber
      seller {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sellerId
      startDate
      status
      subscriptionVariousOperations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    clientId
    createdAt
    dueDate
    invoiceDate
    invoiceLines {
      items {
        id
        amountVatExcluded
        applicationInvoiceId
        calculationMethod
        clientId
        customLabel
        extraInformation
        quantity
        periodFrom
        periodTo
        subscriptionVariousOperationId
        subscriptionUsageHistoryId
        totalAmount
        type
        vatAmount
        vatRate
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    invoiceNumber
    periodFrom
    periodTo
    clientSnapshot {
      name
      vat
      businessNumber
      email
      address {
        street
        number
        box
        postalCode
        city
        country
        __typename
      }
      __typename
    }
    peppolProperties {
      peppolStatus
      peppolId
      peppolErrorType
      peppolErrorMessage
      __typename
    }
    status
    type
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetApplicationInvoiceQueryVariables,
  APITypes.GetApplicationInvoiceQuery
>;
export const listApplicationInvoices = /* GraphQL */ `query ListApplicationInvoices(
  $filter: ModelApplicationInvoiceFilterInput
  $limit: Int
  $nextToken: String
) {
  listApplicationInvoices(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      amount
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMethodId
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      createdAt
      dueDate
      invoiceDate
      invoiceLines {
        nextToken
        startedAt
        __typename
      }
      invoiceNumber
      periodFrom
      periodTo
      clientSnapshot {
        name
        vat
        businessNumber
        email
        __typename
      }
      peppolProperties {
        peppolStatus
        peppolId
        peppolErrorType
        peppolErrorMessage
        __typename
      }
      status
      type
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListApplicationInvoicesQueryVariables,
  APITypes.ListApplicationInvoicesQuery
>;
export const syncApplicationInvoices = /* GraphQL */ `query SyncApplicationInvoices(
  $filter: ModelApplicationInvoiceFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncApplicationInvoices(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      amount
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMethodId
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      createdAt
      dueDate
      invoiceDate
      invoiceLines {
        nextToken
        startedAt
        __typename
      }
      invoiceNumber
      periodFrom
      periodTo
      clientSnapshot {
        name
        vat
        businessNumber
        email
        __typename
      }
      peppolProperties {
        peppolStatus
        peppolId
        peppolErrorType
        peppolErrorMessage
        __typename
      }
      status
      type
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncApplicationInvoicesQueryVariables,
  APITypes.SyncApplicationInvoicesQuery
>;
export const applicationInvoicesByApplicationSubscriptionId = /* GraphQL */ `query ApplicationInvoicesByApplicationSubscriptionId(
  $applicationSubscriptionId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelApplicationInvoiceFilterInput
  $limit: Int
  $nextToken: String
) {
  applicationInvoicesByApplicationSubscriptionId(
    applicationSubscriptionId: $applicationSubscriptionId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      amount
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMethodId
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      createdAt
      dueDate
      invoiceDate
      invoiceLines {
        nextToken
        startedAt
        __typename
      }
      invoiceNumber
      periodFrom
      periodTo
      clientSnapshot {
        name
        vat
        businessNumber
        email
        __typename
      }
      peppolProperties {
        peppolStatus
        peppolId
        peppolErrorType
        peppolErrorMessage
        __typename
      }
      status
      type
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ApplicationInvoicesByApplicationSubscriptionIdQueryVariables,
  APITypes.ApplicationInvoicesByApplicationSubscriptionIdQuery
>;
export const applicationInvoicesByClientIdAndInvoiceDate = /* GraphQL */ `query ApplicationInvoicesByClientIdAndInvoiceDate(
  $clientId: ID!
  $invoiceDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelApplicationInvoiceFilterInput
  $limit: Int
  $nextToken: String
) {
  applicationInvoicesByClientIdAndInvoiceDate(
    clientId: $clientId
    invoiceDate: $invoiceDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      amount
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMethodId
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      createdAt
      dueDate
      invoiceDate
      invoiceLines {
        nextToken
        startedAt
        __typename
      }
      invoiceNumber
      periodFrom
      periodTo
      clientSnapshot {
        name
        vat
        businessNumber
        email
        __typename
      }
      peppolProperties {
        peppolStatus
        peppolId
        peppolErrorType
        peppolErrorMessage
        __typename
      }
      status
      type
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ApplicationInvoicesByClientIdAndInvoiceDateQueryVariables,
  APITypes.ApplicationInvoicesByClientIdAndInvoiceDateQuery
>;
export const applicationInvoicesByStatusAndInvoiceDate = /* GraphQL */ `query ApplicationInvoicesByStatusAndInvoiceDate(
  $status: ApplicationInvoiceStatus!
  $invoiceDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelApplicationInvoiceFilterInput
  $limit: Int
  $nextToken: String
) {
  applicationInvoicesByStatusAndInvoiceDate(
    status: $status
    invoiceDate: $invoiceDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      amount
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMethodId
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      createdAt
      dueDate
      invoiceDate
      invoiceLines {
        nextToken
        startedAt
        __typename
      }
      invoiceNumber
      periodFrom
      periodTo
      clientSnapshot {
        name
        vat
        businessNumber
        email
        __typename
      }
      peppolProperties {
        peppolStatus
        peppolId
        peppolErrorType
        peppolErrorMessage
        __typename
      }
      status
      type
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ApplicationInvoicesByStatusAndInvoiceDateQueryVariables,
  APITypes.ApplicationInvoicesByStatusAndInvoiceDateQuery
>;
export const applicationInvoicesByTypeAndInvoiceDate = /* GraphQL */ `query ApplicationInvoicesByTypeAndInvoiceDate(
  $type: ApplicationInvoiceType!
  $invoiceDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelApplicationInvoiceFilterInput
  $limit: Int
  $nextToken: String
) {
  applicationInvoicesByTypeAndInvoiceDate(
    type: $type
    invoiceDate: $invoiceDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      amount
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMethodId
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      createdAt
      dueDate
      invoiceDate
      invoiceLines {
        nextToken
        startedAt
        __typename
      }
      invoiceNumber
      periodFrom
      periodTo
      clientSnapshot {
        name
        vat
        businessNumber
        email
        __typename
      }
      peppolProperties {
        peppolStatus
        peppolId
        peppolErrorType
        peppolErrorMessage
        __typename
      }
      status
      type
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ApplicationInvoicesByTypeAndInvoiceDateQueryVariables,
  APITypes.ApplicationInvoicesByTypeAndInvoiceDateQuery
>;
export const getApplicationInvoiceLine = /* GraphQL */ `query GetApplicationInvoiceLine($id: ID!) {
  getApplicationInvoiceLine(id: $id) {
    id
    amountVatExcluded
    applicationInvoiceId
    applicationInvoice {
      id
      amount
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMethodId
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      createdAt
      dueDate
      invoiceDate
      invoiceLines {
        nextToken
        startedAt
        __typename
      }
      invoiceNumber
      periodFrom
      periodTo
      clientSnapshot {
        name
        vat
        businessNumber
        email
        __typename
      }
      peppolProperties {
        peppolStatus
        peppolId
        peppolErrorType
        peppolErrorMessage
        __typename
      }
      status
      type
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    calculationDetail {
      amountType
      endNumber
      feeApplied
      minimumFixedUnitPriceThreshold
      startNumber
      unitType
      __typename
    }
    calculationMethod
    clientId
    customLabel
    extraInformation
    quantity
    periodFrom
    periodTo
    subscriptionVariousOperationId
    subscriptionVariousOperation {
      id
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMethodId
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      createdAt
      createdBy {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      endDate
      label
      lastInvoiceDate
      sellerId
      startDate
      subscriptionVariousOperationHistories {
        periodFrom
        periodTo
        amount
        __typename
      }
      type
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    subscriptionUsageHistoryId
    subscriptionUsageHistory {
      id
      clientId
      createdAt
      creditUsageDetail {
        numberUsed
        creditsAccount
        creditOperationType
        __typename
      }
      customerCreatorId
      requestId
      applicationInvoiceId
      storageUsageDetail {
        numberUsed
        __typename
      }
      type
      unitsUsageDetail {
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    totalAmount
    type
    vatAmount
    vatRate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetApplicationInvoiceLineQueryVariables,
  APITypes.GetApplicationInvoiceLineQuery
>;
export const listApplicationInvoiceLines = /* GraphQL */ `query ListApplicationInvoiceLines(
  $filter: ModelApplicationInvoiceLineFilterInput
  $limit: Int
  $nextToken: String
) {
  listApplicationInvoiceLines(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      amountVatExcluded
      applicationInvoiceId
      applicationInvoice {
        id
        amount
        applicationSubscriptionId
        clientId
        createdAt
        dueDate
        invoiceDate
        invoiceNumber
        periodFrom
        periodTo
        status
        type
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      calculationDetail {
        amountType
        endNumber
        feeApplied
        minimumFixedUnitPriceThreshold
        startNumber
        unitType
        __typename
      }
      calculationMethod
      clientId
      customLabel
      extraInformation
      quantity
      periodFrom
      periodTo
      subscriptionVariousOperationId
      subscriptionVariousOperation {
        id
        applicationSubscriptionId
        clientId
        createdAt
        endDate
        label
        lastInvoiceDate
        sellerId
        startDate
        type
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      subscriptionUsageHistoryId
      subscriptionUsageHistory {
        id
        clientId
        createdAt
        customerCreatorId
        requestId
        applicationInvoiceId
        type
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      totalAmount
      type
      vatAmount
      vatRate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListApplicationInvoiceLinesQueryVariables,
  APITypes.ListApplicationInvoiceLinesQuery
>;
export const syncApplicationInvoiceLines = /* GraphQL */ `query SyncApplicationInvoiceLines(
  $filter: ModelApplicationInvoiceLineFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncApplicationInvoiceLines(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      amountVatExcluded
      applicationInvoiceId
      applicationInvoice {
        id
        amount
        applicationSubscriptionId
        clientId
        createdAt
        dueDate
        invoiceDate
        invoiceNumber
        periodFrom
        periodTo
        status
        type
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      calculationDetail {
        amountType
        endNumber
        feeApplied
        minimumFixedUnitPriceThreshold
        startNumber
        unitType
        __typename
      }
      calculationMethod
      clientId
      customLabel
      extraInformation
      quantity
      periodFrom
      periodTo
      subscriptionVariousOperationId
      subscriptionVariousOperation {
        id
        applicationSubscriptionId
        clientId
        createdAt
        endDate
        label
        lastInvoiceDate
        sellerId
        startDate
        type
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      subscriptionUsageHistoryId
      subscriptionUsageHistory {
        id
        clientId
        createdAt
        customerCreatorId
        requestId
        applicationInvoiceId
        type
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      totalAmount
      type
      vatAmount
      vatRate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncApplicationInvoiceLinesQueryVariables,
  APITypes.SyncApplicationInvoiceLinesQuery
>;
export const applicationInvoiceLinesByApplicationInvoiceId = /* GraphQL */ `query ApplicationInvoiceLinesByApplicationInvoiceId(
  $applicationInvoiceId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelApplicationInvoiceLineFilterInput
  $limit: Int
  $nextToken: String
) {
  applicationInvoiceLinesByApplicationInvoiceId(
    applicationInvoiceId: $applicationInvoiceId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      amountVatExcluded
      applicationInvoiceId
      applicationInvoice {
        id
        amount
        applicationSubscriptionId
        clientId
        createdAt
        dueDate
        invoiceDate
        invoiceNumber
        periodFrom
        periodTo
        status
        type
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      calculationDetail {
        amountType
        endNumber
        feeApplied
        minimumFixedUnitPriceThreshold
        startNumber
        unitType
        __typename
      }
      calculationMethod
      clientId
      customLabel
      extraInformation
      quantity
      periodFrom
      periodTo
      subscriptionVariousOperationId
      subscriptionVariousOperation {
        id
        applicationSubscriptionId
        clientId
        createdAt
        endDate
        label
        lastInvoiceDate
        sellerId
        startDate
        type
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      subscriptionUsageHistoryId
      subscriptionUsageHistory {
        id
        clientId
        createdAt
        customerCreatorId
        requestId
        applicationInvoiceId
        type
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      totalAmount
      type
      vatAmount
      vatRate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ApplicationInvoiceLinesByApplicationInvoiceIdQueryVariables,
  APITypes.ApplicationInvoiceLinesByApplicationInvoiceIdQuery
>;
export const applicationInvoiceLinesByClientId = /* GraphQL */ `query ApplicationInvoiceLinesByClientId(
  $clientId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelApplicationInvoiceLineFilterInput
  $limit: Int
  $nextToken: String
) {
  applicationInvoiceLinesByClientId(
    clientId: $clientId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      amountVatExcluded
      applicationInvoiceId
      applicationInvoice {
        id
        amount
        applicationSubscriptionId
        clientId
        createdAt
        dueDate
        invoiceDate
        invoiceNumber
        periodFrom
        periodTo
        status
        type
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      calculationDetail {
        amountType
        endNumber
        feeApplied
        minimumFixedUnitPriceThreshold
        startNumber
        unitType
        __typename
      }
      calculationMethod
      clientId
      customLabel
      extraInformation
      quantity
      periodFrom
      periodTo
      subscriptionVariousOperationId
      subscriptionVariousOperation {
        id
        applicationSubscriptionId
        clientId
        createdAt
        endDate
        label
        lastInvoiceDate
        sellerId
        startDate
        type
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      subscriptionUsageHistoryId
      subscriptionUsageHistory {
        id
        clientId
        createdAt
        customerCreatorId
        requestId
        applicationInvoiceId
        type
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      totalAmount
      type
      vatAmount
      vatRate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ApplicationInvoiceLinesByClientIdQueryVariables,
  APITypes.ApplicationInvoiceLinesByClientIdQuery
>;
export const applicationInvoiceLinesBySubscriptionVariousOperationId = /* GraphQL */ `query ApplicationInvoiceLinesBySubscriptionVariousOperationId(
  $subscriptionVariousOperationId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelApplicationInvoiceLineFilterInput
  $limit: Int
  $nextToken: String
) {
  applicationInvoiceLinesBySubscriptionVariousOperationId(
    subscriptionVariousOperationId: $subscriptionVariousOperationId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      amountVatExcluded
      applicationInvoiceId
      applicationInvoice {
        id
        amount
        applicationSubscriptionId
        clientId
        createdAt
        dueDate
        invoiceDate
        invoiceNumber
        periodFrom
        periodTo
        status
        type
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      calculationDetail {
        amountType
        endNumber
        feeApplied
        minimumFixedUnitPriceThreshold
        startNumber
        unitType
        __typename
      }
      calculationMethod
      clientId
      customLabel
      extraInformation
      quantity
      periodFrom
      periodTo
      subscriptionVariousOperationId
      subscriptionVariousOperation {
        id
        applicationSubscriptionId
        clientId
        createdAt
        endDate
        label
        lastInvoiceDate
        sellerId
        startDate
        type
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      subscriptionUsageHistoryId
      subscriptionUsageHistory {
        id
        clientId
        createdAt
        customerCreatorId
        requestId
        applicationInvoiceId
        type
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      totalAmount
      type
      vatAmount
      vatRate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ApplicationInvoiceLinesBySubscriptionVariousOperationIdQueryVariables,
  APITypes.ApplicationInvoiceLinesBySubscriptionVariousOperationIdQuery
>;
export const applicationInvoiceLinesBySubscriptionUsageHistoryId = /* GraphQL */ `query ApplicationInvoiceLinesBySubscriptionUsageHistoryId(
  $subscriptionUsageHistoryId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelApplicationInvoiceLineFilterInput
  $limit: Int
  $nextToken: String
) {
  applicationInvoiceLinesBySubscriptionUsageHistoryId(
    subscriptionUsageHistoryId: $subscriptionUsageHistoryId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      amountVatExcluded
      applicationInvoiceId
      applicationInvoice {
        id
        amount
        applicationSubscriptionId
        clientId
        createdAt
        dueDate
        invoiceDate
        invoiceNumber
        periodFrom
        periodTo
        status
        type
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      calculationDetail {
        amountType
        endNumber
        feeApplied
        minimumFixedUnitPriceThreshold
        startNumber
        unitType
        __typename
      }
      calculationMethod
      clientId
      customLabel
      extraInformation
      quantity
      periodFrom
      periodTo
      subscriptionVariousOperationId
      subscriptionVariousOperation {
        id
        applicationSubscriptionId
        clientId
        createdAt
        endDate
        label
        lastInvoiceDate
        sellerId
        startDate
        type
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      subscriptionUsageHistoryId
      subscriptionUsageHistory {
        id
        clientId
        createdAt
        customerCreatorId
        requestId
        applicationInvoiceId
        type
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      totalAmount
      type
      vatAmount
      vatRate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ApplicationInvoiceLinesBySubscriptionUsageHistoryIdQueryVariables,
  APITypes.ApplicationInvoiceLinesBySubscriptionUsageHistoryIdQuery
>;
export const getApplicationPlan = /* GraphQL */ `query GetApplicationPlan($id: ID!) {
  getApplicationPlan(id: $id) {
    id
    calculationDetails {
      amountType
      endNumber
      feeApplied
      minimumFixedUnitPriceThreshold
      startNumber
      unitType
      __typename
    }
    calculationMethod
    includedVariousOperations {
      items {
        id
        amount
        customerVisible
        duration
        numberOfCredits
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        applicationPlanIncludedVariousOperationsId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    isBillable
    isDefaultPlan
    labels {
      language
      label
      __typename
    }
    numberOfTrialMonths
    setupFees
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetApplicationPlanQueryVariables,
  APITypes.GetApplicationPlanQuery
>;
export const listApplicationPlans = /* GraphQL */ `query ListApplicationPlans(
  $filter: ModelApplicationPlanFilterInput
  $limit: Int
  $nextToken: String
) {
  listApplicationPlans(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      calculationDetails {
        amountType
        endNumber
        feeApplied
        minimumFixedUnitPriceThreshold
        startNumber
        unitType
        __typename
      }
      calculationMethod
      includedVariousOperations {
        nextToken
        startedAt
        __typename
      }
      isBillable
      isDefaultPlan
      labels {
        language
        label
        __typename
      }
      numberOfTrialMonths
      setupFees
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListApplicationPlansQueryVariables,
  APITypes.ListApplicationPlansQuery
>;
export const syncApplicationPlans = /* GraphQL */ `query SyncApplicationPlans(
  $filter: ModelApplicationPlanFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncApplicationPlans(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      calculationDetails {
        amountType
        endNumber
        feeApplied
        minimumFixedUnitPriceThreshold
        startNumber
        unitType
        __typename
      }
      calculationMethod
      includedVariousOperations {
        nextToken
        startedAt
        __typename
      }
      isBillable
      isDefaultPlan
      labels {
        language
        label
        __typename
      }
      numberOfTrialMonths
      setupFees
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncApplicationPlansQueryVariables,
  APITypes.SyncApplicationPlansQuery
>;
export const getApplicationSubscription = /* GraphQL */ `query GetApplicationSubscription($id: ID!) {
  getApplicationSubscription(id: $id) {
    id
    clientId
    creditsBalancePaid
    creditsBalanceIncluded
    creditsConfiguration {
      allowPostPaid
      creditsNotification
      postPaidThreshold
      __typename
    }
    endDate
    language
    lastInvoiceDate
    paymentCustomerId
    paymentLastExecution
    paymentLastStatus
    paymentLastError
    paymentMethodId
    paymentMode
    paymentTerms
    invoicesProperties {
      hideQuantities
      __typename
    }
    plan {
      id
      calculationDetails {
        amountType
        endNumber
        feeApplied
        minimumFixedUnitPriceThreshold
        startNumber
        unitType
        __typename
      }
      calculationMethod
      includedVariousOperations {
        nextToken
        startedAt
        __typename
      }
      isBillable
      isDefaultPlan
      labels {
        language
        label
        __typename
      }
      numberOfTrialMonths
      setupFees
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    planId
    referenceNumber
    seller {
      id
      cognitoSub
      email
      firstName
      language
      lastName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    sellerId
    startDate
    status
    subscriptionVariousOperations {
      items {
        id
        applicationSubscriptionId
        clientId
        createdAt
        endDate
        label
        lastInvoiceDate
        sellerId
        startDate
        type
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetApplicationSubscriptionQueryVariables,
  APITypes.GetApplicationSubscriptionQuery
>;
export const listApplicationSubscriptions = /* GraphQL */ `query ListApplicationSubscriptions(
  $filter: ModelApplicationSubscriptionFilterInput
  $limit: Int
  $nextToken: String
) {
  listApplicationSubscriptions(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      clientId
      creditsBalancePaid
      creditsBalanceIncluded
      creditsConfiguration {
        allowPostPaid
        creditsNotification
        postPaidThreshold
        __typename
      }
      endDate
      language
      lastInvoiceDate
      paymentCustomerId
      paymentLastExecution
      paymentLastStatus
      paymentLastError
      paymentMethodId
      paymentMode
      paymentTerms
      invoicesProperties {
        hideQuantities
        __typename
      }
      plan {
        id
        calculationMethod
        isBillable
        isDefaultPlan
        numberOfTrialMonths
        setupFees
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      planId
      referenceNumber
      seller {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sellerId
      startDate
      status
      subscriptionVariousOperations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListApplicationSubscriptionsQueryVariables,
  APITypes.ListApplicationSubscriptionsQuery
>;
export const syncApplicationSubscriptions = /* GraphQL */ `query SyncApplicationSubscriptions(
  $filter: ModelApplicationSubscriptionFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncApplicationSubscriptions(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      clientId
      creditsBalancePaid
      creditsBalanceIncluded
      creditsConfiguration {
        allowPostPaid
        creditsNotification
        postPaidThreshold
        __typename
      }
      endDate
      language
      lastInvoiceDate
      paymentCustomerId
      paymentLastExecution
      paymentLastStatus
      paymentLastError
      paymentMethodId
      paymentMode
      paymentTerms
      invoicesProperties {
        hideQuantities
        __typename
      }
      plan {
        id
        calculationMethod
        isBillable
        isDefaultPlan
        numberOfTrialMonths
        setupFees
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      planId
      referenceNumber
      seller {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sellerId
      startDate
      status
      subscriptionVariousOperations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncApplicationSubscriptionsQueryVariables,
  APITypes.SyncApplicationSubscriptionsQuery
>;
export const applicationSubscriptionsByClientId = /* GraphQL */ `query ApplicationSubscriptionsByClientId(
  $clientId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelApplicationSubscriptionFilterInput
  $limit: Int
  $nextToken: String
) {
  applicationSubscriptionsByClientId(
    clientId: $clientId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      clientId
      creditsBalancePaid
      creditsBalanceIncluded
      creditsConfiguration {
        allowPostPaid
        creditsNotification
        postPaidThreshold
        __typename
      }
      endDate
      language
      lastInvoiceDate
      paymentCustomerId
      paymentLastExecution
      paymentLastStatus
      paymentLastError
      paymentMethodId
      paymentMode
      paymentTerms
      invoicesProperties {
        hideQuantities
        __typename
      }
      plan {
        id
        calculationMethod
        isBillable
        isDefaultPlan
        numberOfTrialMonths
        setupFees
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      planId
      referenceNumber
      seller {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sellerId
      startDate
      status
      subscriptionVariousOperations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ApplicationSubscriptionsByClientIdQueryVariables,
  APITypes.ApplicationSubscriptionsByClientIdQuery
>;
export const applicationSubscriptionsByStatusAndStartDate = /* GraphQL */ `query ApplicationSubscriptionsByStatusAndStartDate(
  $status: ApplicationSubscriptionStatus!
  $startDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelApplicationSubscriptionFilterInput
  $limit: Int
  $nextToken: String
) {
  applicationSubscriptionsByStatusAndStartDate(
    status: $status
    startDate: $startDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      clientId
      creditsBalancePaid
      creditsBalanceIncluded
      creditsConfiguration {
        allowPostPaid
        creditsNotification
        postPaidThreshold
        __typename
      }
      endDate
      language
      lastInvoiceDate
      paymentCustomerId
      paymentLastExecution
      paymentLastStatus
      paymentLastError
      paymentMethodId
      paymentMode
      paymentTerms
      invoicesProperties {
        hideQuantities
        __typename
      }
      plan {
        id
        calculationMethod
        isBillable
        isDefaultPlan
        numberOfTrialMonths
        setupFees
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      planId
      referenceNumber
      seller {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sellerId
      startDate
      status
      subscriptionVariousOperations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ApplicationSubscriptionsByStatusAndStartDateQueryVariables,
  APITypes.ApplicationSubscriptionsByStatusAndStartDateQuery
>;
export const getApplicationSubscriptionVariousOperation = /* GraphQL */ `query GetApplicationSubscriptionVariousOperation($id: ID!) {
  getApplicationSubscriptionVariousOperation(id: $id) {
    id
    applicationSubscriptionId
    applicationSubscription {
      id
      clientId
      creditsBalancePaid
      creditsBalanceIncluded
      creditsConfiguration {
        allowPostPaid
        creditsNotification
        postPaidThreshold
        __typename
      }
      endDate
      language
      lastInvoiceDate
      paymentCustomerId
      paymentLastExecution
      paymentLastStatus
      paymentLastError
      paymentMethodId
      paymentMode
      paymentTerms
      invoicesProperties {
        hideQuantities
        __typename
      }
      plan {
        id
        calculationMethod
        isBillable
        isDefaultPlan
        numberOfTrialMonths
        setupFees
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      planId
      referenceNumber
      seller {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sellerId
      startDate
      status
      subscriptionVariousOperations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    clientId
    createdAt
    createdBy {
      id
      cognitoSub
      email
      firstName
      language
      lastName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    endDate
    label
    lastInvoiceDate
    sellerId
    startDate
    subscriptionVariousOperationHistories {
      periodFrom
      periodTo
      amount
      __typename
    }
    type
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetApplicationSubscriptionVariousOperationQueryVariables,
  APITypes.GetApplicationSubscriptionVariousOperationQuery
>;
export const listApplicationSubscriptionVariousOperations = /* GraphQL */ `query ListApplicationSubscriptionVariousOperations(
  $filter: ModelApplicationSubscriptionVariousOperationFilterInput
  $limit: Int
  $nextToken: String
) {
  listApplicationSubscriptionVariousOperations(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMethodId
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      createdAt
      createdBy {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      endDate
      label
      lastInvoiceDate
      sellerId
      startDate
      subscriptionVariousOperationHistories {
        periodFrom
        periodTo
        amount
        __typename
      }
      type
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListApplicationSubscriptionVariousOperationsQueryVariables,
  APITypes.ListApplicationSubscriptionVariousOperationsQuery
>;
export const syncApplicationSubscriptionVariousOperations = /* GraphQL */ `query SyncApplicationSubscriptionVariousOperations(
  $filter: ModelApplicationSubscriptionVariousOperationFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncApplicationSubscriptionVariousOperations(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMethodId
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      createdAt
      createdBy {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      endDate
      label
      lastInvoiceDate
      sellerId
      startDate
      subscriptionVariousOperationHistories {
        periodFrom
        periodTo
        amount
        __typename
      }
      type
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncApplicationSubscriptionVariousOperationsQueryVariables,
  APITypes.SyncApplicationSubscriptionVariousOperationsQuery
>;
export const applicationSubscriptionVariousOperationsByApplicationSubscriptionId = /* GraphQL */ `query ApplicationSubscriptionVariousOperationsByApplicationSubscriptionId(
  $applicationSubscriptionId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelApplicationSubscriptionVariousOperationFilterInput
  $limit: Int
  $nextToken: String
) {
  applicationSubscriptionVariousOperationsByApplicationSubscriptionId(
    applicationSubscriptionId: $applicationSubscriptionId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMethodId
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      createdAt
      createdBy {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      endDate
      label
      lastInvoiceDate
      sellerId
      startDate
      subscriptionVariousOperationHistories {
        periodFrom
        periodTo
        amount
        __typename
      }
      type
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ApplicationSubscriptionVariousOperationsByApplicationSubscriptionIdQueryVariables,
  APITypes.ApplicationSubscriptionVariousOperationsByApplicationSubscriptionIdQuery
>;
export const applicationSubscriptionVariousOperationsByClientId = /* GraphQL */ `query ApplicationSubscriptionVariousOperationsByClientId(
  $clientId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelApplicationSubscriptionVariousOperationFilterInput
  $limit: Int
  $nextToken: String
) {
  applicationSubscriptionVariousOperationsByClientId(
    clientId: $clientId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMethodId
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      createdAt
      createdBy {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      endDate
      label
      lastInvoiceDate
      sellerId
      startDate
      subscriptionVariousOperationHistories {
        periodFrom
        periodTo
        amount
        __typename
      }
      type
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ApplicationSubscriptionVariousOperationsByClientIdQueryVariables,
  APITypes.ApplicationSubscriptionVariousOperationsByClientIdQuery
>;
export const getApplicationVariousOperation = /* GraphQL */ `query GetApplicationVariousOperation($id: ID!) {
  getApplicationVariousOperation(id: $id) {
    id
    amount
    customerVisible
    duration
    labels {
      language
      label
      __typename
    }
    numberOfCredits
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    applicationPlanIncludedVariousOperationsId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetApplicationVariousOperationQueryVariables,
  APITypes.GetApplicationVariousOperationQuery
>;
export const listApplicationVariousOperations = /* GraphQL */ `query ListApplicationVariousOperations(
  $filter: ModelApplicationVariousOperationFilterInput
  $limit: Int
  $nextToken: String
) {
  listApplicationVariousOperations(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      amount
      customerVisible
      duration
      labels {
        language
        label
        __typename
      }
      numberOfCredits
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      applicationPlanIncludedVariousOperationsId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListApplicationVariousOperationsQueryVariables,
  APITypes.ListApplicationVariousOperationsQuery
>;
export const syncApplicationVariousOperations = /* GraphQL */ `query SyncApplicationVariousOperations(
  $filter: ModelApplicationVariousOperationFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncApplicationVariousOperations(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      amount
      customerVisible
      duration
      labels {
        language
        label
        __typename
      }
      numberOfCredits
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      applicationPlanIncludedVariousOperationsId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncApplicationVariousOperationsQueryVariables,
  APITypes.SyncApplicationVariousOperationsQuery
>;
export const getCompanyUser = /* GraphQL */ `query GetCompanyUser($id: ID!) {
  getCompanyUser(id: $id) {
    id
    cognitoSub
    email
    firstName
    language
    lastName
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCompanyUserQueryVariables,
  APITypes.GetCompanyUserQuery
>;
export const listCompanyUsers = /* GraphQL */ `query ListCompanyUsers(
  $filter: ModelCompanyUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listCompanyUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      cognitoSub
      email
      firstName
      language
      lastName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCompanyUsersQueryVariables,
  APITypes.ListCompanyUsersQuery
>;
export const syncCompanyUsers = /* GraphQL */ `query SyncCompanyUsers(
  $filter: ModelCompanyUserFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncCompanyUsers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      cognitoSub
      email
      firstName
      language
      lastName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncCompanyUsersQueryVariables,
  APITypes.SyncCompanyUsersQuery
>;
export const companyUsersByEmail = /* GraphQL */ `query CompanyUsersByEmail(
  $email: String!
  $sortDirection: ModelSortDirection
  $filter: ModelCompanyUserFilterInput
  $limit: Int
  $nextToken: String
) {
  companyUsersByEmail(
    email: $email
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      cognitoSub
      email
      firstName
      language
      lastName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CompanyUsersByEmailQueryVariables,
  APITypes.CompanyUsersByEmailQuery
>;
export const getCreditCost = /* GraphQL */ `query GetCreditCost($id: ID!) {
  getCreditCost(id: $id) {
    id
    clientId
    endDate
    numberOfCredits
    price
    startDate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCreditCostQueryVariables,
  APITypes.GetCreditCostQuery
>;
export const listCreditCosts = /* GraphQL */ `query ListCreditCosts(
  $filter: ModelCreditCostFilterInput
  $limit: Int
  $nextToken: String
) {
  listCreditCosts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      clientId
      endDate
      numberOfCredits
      price
      startDate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCreditCostsQueryVariables,
  APITypes.ListCreditCostsQuery
>;
export const syncCreditCosts = /* GraphQL */ `query SyncCreditCosts(
  $filter: ModelCreditCostFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncCreditCosts(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      clientId
      endDate
      numberOfCredits
      price
      startDate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncCreditCostsQueryVariables,
  APITypes.SyncCreditCostsQuery
>;
export const creditCostsByClientIdAndStartDate = /* GraphQL */ `query CreditCostsByClientIdAndStartDate(
  $clientId: ID!
  $startDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCreditCostFilterInput
  $limit: Int
  $nextToken: String
) {
  creditCostsByClientIdAndStartDate(
    clientId: $clientId
    startDate: $startDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      clientId
      endDate
      numberOfCredits
      price
      startDate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CreditCostsByClientIdAndStartDateQueryVariables,
  APITypes.CreditCostsByClientIdAndStartDateQuery
>;
export const getCreditUsageCost = /* GraphQL */ `query GetCreditUsageCost($id: ID!) {
  getCreditUsageCost(id: $id) {
    id
    endDate
    numberOfCreditsPerOperation
    startDate
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCreditUsageCostQueryVariables,
  APITypes.GetCreditUsageCostQuery
>;
export const listCreditUsageCosts = /* GraphQL */ `query ListCreditUsageCosts(
  $filter: ModelCreditUsageCostFilterInput
  $limit: Int
  $nextToken: String
) {
  listCreditUsageCosts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      endDate
      numberOfCreditsPerOperation
      startDate
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCreditUsageCostsQueryVariables,
  APITypes.ListCreditUsageCostsQuery
>;
export const syncCreditUsageCosts = /* GraphQL */ `query SyncCreditUsageCosts(
  $filter: ModelCreditUsageCostFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncCreditUsageCosts(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      endDate
      numberOfCreditsPerOperation
      startDate
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncCreditUsageCostsQueryVariables,
  APITypes.SyncCreditUsageCostsQuery
>;
export const getSubscriptionUsageHistory = /* GraphQL */ `query GetSubscriptionUsageHistory($id: ID!) {
  getSubscriptionUsageHistory(id: $id) {
    id
    clientId
    createdAt
    creditUsageDetail {
      numberUsed
      creditsAccount
      creditOperationType
      __typename
    }
    customerCreatorId
    requestId
    applicationInvoiceId
    storageUsageDetail {
      numberUsed
      __typename
    }
    type
    unitsUsageDetail {
      unitsUsage {
        numberUsed
        unitId
        lastKnownLeasePrice
        advertisedRentalPrice
        type
        __typename
      }
      proRataUnits {
        unitId
        numberOfDays
        lastKnownLeasePrice
        advertisedRentalPrice
        type
        __typename
      }
      __typename
    }
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSubscriptionUsageHistoryQueryVariables,
  APITypes.GetSubscriptionUsageHistoryQuery
>;
export const listSubscriptionUsageHistories = /* GraphQL */ `query ListSubscriptionUsageHistories(
  $filter: ModelSubscriptionUsageHistoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listSubscriptionUsageHistories(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      clientId
      createdAt
      creditUsageDetail {
        numberUsed
        creditsAccount
        creditOperationType
        __typename
      }
      customerCreatorId
      requestId
      applicationInvoiceId
      storageUsageDetail {
        numberUsed
        __typename
      }
      type
      unitsUsageDetail {
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSubscriptionUsageHistoriesQueryVariables,
  APITypes.ListSubscriptionUsageHistoriesQuery
>;
export const syncSubscriptionUsageHistories = /* GraphQL */ `query SyncSubscriptionUsageHistories(
  $filter: ModelSubscriptionUsageHistoryFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncSubscriptionUsageHistories(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      clientId
      createdAt
      creditUsageDetail {
        numberUsed
        creditsAccount
        creditOperationType
        __typename
      }
      customerCreatorId
      requestId
      applicationInvoiceId
      storageUsageDetail {
        numberUsed
        __typename
      }
      type
      unitsUsageDetail {
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncSubscriptionUsageHistoriesQueryVariables,
  APITypes.SyncSubscriptionUsageHistoriesQuery
>;
export const subscriptionUsageHistoriesByClientIdAndCreatedAt = /* GraphQL */ `query SubscriptionUsageHistoriesByClientIdAndCreatedAt(
  $clientId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelSubscriptionUsageHistoryFilterInput
  $limit: Int
  $nextToken: String
) {
  subscriptionUsageHistoriesByClientIdAndCreatedAt(
    clientId: $clientId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      clientId
      createdAt
      creditUsageDetail {
        numberUsed
        creditsAccount
        creditOperationType
        __typename
      }
      customerCreatorId
      requestId
      applicationInvoiceId
      storageUsageDetail {
        numberUsed
        __typename
      }
      type
      unitsUsageDetail {
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SubscriptionUsageHistoriesByClientIdAndCreatedAtQueryVariables,
  APITypes.SubscriptionUsageHistoriesByClientIdAndCreatedAtQuery
>;
export const subscriptionUsageHistoriesByRequestIdAndCreatedAt = /* GraphQL */ `query SubscriptionUsageHistoriesByRequestIdAndCreatedAt(
  $requestId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelSubscriptionUsageHistoryFilterInput
  $limit: Int
  $nextToken: String
) {
  subscriptionUsageHistoriesByRequestIdAndCreatedAt(
    requestId: $requestId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      clientId
      createdAt
      creditUsageDetail {
        numberUsed
        creditsAccount
        creditOperationType
        __typename
      }
      customerCreatorId
      requestId
      applicationInvoiceId
      storageUsageDetail {
        numberUsed
        __typename
      }
      type
      unitsUsageDetail {
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SubscriptionUsageHistoriesByRequestIdAndCreatedAtQueryVariables,
  APITypes.SubscriptionUsageHistoriesByRequestIdAndCreatedAtQuery
>;
export const subscriptionUsageHistoriesByApplicationInvoiceId = /* GraphQL */ `query SubscriptionUsageHistoriesByApplicationInvoiceId(
  $applicationInvoiceId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelSubscriptionUsageHistoryFilterInput
  $limit: Int
  $nextToken: String
) {
  subscriptionUsageHistoriesByApplicationInvoiceId(
    applicationInvoiceId: $applicationInvoiceId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      clientId
      createdAt
      creditUsageDetail {
        numberUsed
        creditsAccount
        creditOperationType
        __typename
      }
      customerCreatorId
      requestId
      applicationInvoiceId
      storageUsageDetail {
        numberUsed
        __typename
      }
      type
      unitsUsageDetail {
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SubscriptionUsageHistoriesByApplicationInvoiceIdQueryVariables,
  APITypes.SubscriptionUsageHistoriesByApplicationInvoiceIdQuery
>;
export const getCreditCostsForClient = /* GraphQL */ `query GetCreditCostsForClient($filter: ModelCreditCostFilterInput!) {
  getCreditCostsForClient(filter: $filter) {
    items {
      id
      clientId
      endDate
      numberOfCredits
      price
      startDate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCreditCostsForClientQueryVariables,
  APITypes.GetCreditCostsForClientQuery
>;
